<template>
    <div>
        <label>Terminal</label>
        <b-form-select :disabled="loading" class="mb-2" v-model="form.terminal" :options="terminals" label-field="name" text-field="name" value-field="terminalId"></b-form-select>

        <TextEditor :disabled="loading" :entity="form" label="Beløb" alias="amount" :validate="true" scope="payment"></TextEditor>


        <div v-if="loading">
            <div class="d-flex justify-content-center align-items-center font-lg">
                Afventer betaling...
                <b-spinner variant="primary" class="m-3"></b-spinner>
            </div>
            <div class="d-flex justify-content-center">
                <b-button @click="cancelPayment" variant="danger" class="mt-2">Afbryd betaling</b-button>
            </div>
        </div>

    </div>
</template>

<script>
    import UserPicker from "../../_ui/editors/user";
    import TextEditor from "../../_ui/editors/text";

    export default {
        data: () => ({
            form: {
                terminal: null,
                amount: null,
                transactionReference: null
            },
            terminals: [],

            loading: false,
            intervalId: null,
        }),
        components: { TextEditor },
        computed: {},
        watch: {},
        props: ["entity", "update"],
        methods: {
            getTerminals() {
                this.$http.get("/api/flatpay/terminals").then(x => {
                    this.terminals = x.data.filter(x => x.name)

                    var defaultTerminal = this.terminals.find(x => x.default)
                    if (defaultTerminal) {
                        this.form.terminal = defaultTerminal.terminalId
                    }
                })
            },
            ok() {
                this.$validator.validate("payment.*").then(valid => {
                    if (valid) {
                        var model = {
                            terminalId: this.form.terminal,
                            amount: this.form.amount,
                            reference: this.entity.number,
                            externalReference: this.entity.Id
                        }

                        this.$http.post("/api/flatpay/start-transaction", model).then(x => {
                            if (x.data) {
                                this.form.transactionReference = x.data.transactionReference
                                this.startListener()

                                this.update()
                            } else {
                                this.update(false)
                            }
                        });

                    }
                })
            },
            cancel() {
                this.stopListener()

                if (this.form.transactionReference) {
                    var model = {
                        terminalId: this.form.terminal,
                        transactionReference: this.form.transactionReference,
                        externalReference: this.entity.Id
                    }

                    this.$http.post(`/api/flatpay/cancel-transaction/${this.entity.Id}`, model);
                }

                this.$emit("close");
            },


            cancelPayment() {
                this.stopListener()

                var model = {
                    terminalId: this.form.terminal,
                    transactionReference: this.form.transactionReference,
                    externalReference: this.entity.Id
                }

                this.$http.post(`/api/flatpay/cancel-transaction/${this.entity.Id}`, model);
            },

            startListener() {
                if (!this.loading) {
                    this.loading = true;
                    this.intervalId = setInterval(() => {
                        if (this.loading) {
                            // your logic here
                            var model = {
                                terminalId: this.form.terminal,
                                transactionReference: this.form.transactionReference,
                                externalReference: this.entity.Id
                            }

                            this.$http.post(`/api/flatpay/transaction/${this.entity.Id}`, model).then(x => {
                                if (x.data.status == "COMPLETED") {
                                    console.log("COMPLETED")

                                    this.update(true)
                                    this.stopListener()
                                    this.form.transactionReference = null

                                    this.$emit("close");
                                }
                                else if (x.data.status == "CANCELLED") {
                                    console.log("CANCELLED")

                                    this.update(false, "Payment cancelled!")
                                    this.stopListener()
                                    this.form.transactionReference = null
                                }
                            });
                        }
                    }, 2500);
                }
            },
            stopListener() {
                this.loading = false;
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                    this.intervalId = null;
                }
            },
        },
        created() {
            this.getTerminals()
        },
        mounted() {
            //this.form.amount = this.entity.total
            this.form.amount = this.$numeral(this.entity.total).format("0.[00]")
        },
        beforeDestroy() {
            // Clean up the interval when the component is destroyed
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
        }
    };
</script>